export const tagPresets = {
    printers: {
        zebra_9x5: {
            name: "Zebra (9cm x 5cm) - Padrão Horizontal",
            widthMm: 90,
            heightMm: 50,
            showQr: true,
            qrSide: "left",
            qrCodePosition: { top: 14, left: 2 },
            qrCodeSizeMm: 20,
            showSecondQr: false,
            secondQrSide: "right",
            secondQrCodePosition: { top: 14, left: 2 },
            secondQrCodeSizeMm: 20,
            secondQrValue: "#anm2026",
            textAreaLeft: 24,
            textAreaTop: 12,
            textAreaSpacing: 1,
            showName: true, nameFontSize: 15, nameUppercase: true, nameItalic: false,
            showCompany: true, companyFontSize: 12, companyUppercase: false, companyItalic: false,
            showRole: true, roleFontSize: 14, roleUppercase: false, roleItalic: false,
            itemOrder: ["role", "name", "company"],
        },
        brother_10x5: {
            name: "Brother / Zebra (10cm x 5cm) - Horizontal Largo",
            widthMm: 100,
            heightMm: 50,
            showQr: true,
            qrSide: "left",
            qrCodePosition: { top: 14, left: 2 },
            qrCodeSizeMm: 20,
            showSecondQr: false,
            secondQrSide: "right",
            secondQrCodePosition: { top: 14, left: 2 },
            secondQrCodeSizeMm: 20,
            secondQrValue: "#anm2026",
            textAreaLeft: 24,
            textAreaTop: 14,
            textAreaSpacing: 1,
            showName: true, nameFontSize: 15, nameUppercase: true, nameItalic: false,
            showCompany: true, companyFontSize: 14, companyUppercase: false, companyItalic: false,
            showRole: true, roleFontSize: 15, roleUppercase: false, roleItalic: false,
            itemOrder: ["role", "name", "company"],
        },
        zebra_vertical_5x9: {
            name: "Zebra (5cm x 9cm) - Padrão Vertical",
            widthMm: 50,
            heightMm: 90,
            showQr: true,
            qrSide: "left",
            qrCodePosition: { top: 55, left: 12 },
            qrCodeSizeMm: 20,
            showSecondQr: false,
            secondQrSide: "right",
            secondQrCodePosition: { top: 55, left: 2 },
            secondQrCodeSizeMm: 20,
            secondQrValue: "#anm2026",
            textAreaLeft: 5,
            textAreaTop: 10,
            textAreaSpacing: 1,
            showName: true, nameFontSize: 15, nameUppercase: true, nameItalic: false,
            showCompany: true, companyFontSize: 14, companyUppercase: false, companyItalic: false,
            showRole: true, roleFontSize: 15, roleUppercase: false, roleItalic: false,
            itemOrder: ["role", "name", "company"],
        },
        ticket_8x4: {
            name: "Ingresso Térmico Pequeno (8cm x 4cm)",
            widthMm: 80,
            heightMm: 40,
            showQr: true,
            qrSide: "left",
            qrCodePosition: { top: 10, left: 2 },
            qrCodeSizeMm: 18,
            showSecondQr: false,
            secondQrSide: "right",
            secondQrCodePosition: { top: 10, left: 2 },
            secondQrCodeSizeMm: 18,
            secondQrValue: "#anm2026",
            textAreaLeft: 22,
            textAreaTop: 10,
            textAreaSpacing: 1,
            showName: true, nameFontSize: 15, nameUppercase: true, nameItalic: false,
            showCompany: true, companyFontSize: 14, companyUppercase: false, companyItalic: false,
            showRole: true, roleFontSize: 15, roleUppercase: false, roleItalic: false,
            itemOrder: ["role", "name", "company"],
        },
        text_only_9x5: {
            name: "Somente Texto Centralizado (9cm x 5cm)",
            widthMm: 90,
            heightMm: 50,
            showQr: false,
            qrSide: "left",
            qrCodePosition: { top: 0, left: 0 },
            qrCodeSizeMm: 0,
            showSecondQr: false,
            secondQrSide: "right",
            secondQrCodePosition: { top: 14, left: 2 },
            secondQrCodeSizeMm: 20,
            secondQrValue: "#anm2026",
            textAreaLeft: 5,
            textAreaTop: 12,
            textAreaSpacing: 1,
            showName: true, nameFontSize: 15, nameUppercase: true, nameItalic: false,
            showCompany: true, companyFontSize: 14, companyUppercase: false, companyItalic: false,
            showRole: true, roleFontSize: 15, roleUppercase: false, companyItalic: false,
            itemOrder: ["role", "name", "company"],
        },
    },

    events: {
        "1": {
            widthMm: 90,
            heightMm: 50,
            showQr: true,
            qrSide: "left",
            qrCodePosition: { top: 14, left: 2 },
            qrCodeSizeMm: 20,
            showSecondQr: false,
            secondQrSide: "right",
            secondQrCodePosition: { top: 14, left: 2 },
            secondQrCodeSizeMm: 20,
            secondQrValue: "#anm2026",
            textAreaLeft: 24,
            textAreaTop: 14,
            textAreaSpacing: 1,
            showName: true, nameFontSize: 15, nameUppercase: true, nameItalic: false,
            showCompany: true, companyFontSize: 14, companyUppercase: false, companyItalic: false,
            showRole: true, roleFontSize: 15, roleUppercase: false, roleItalic: false,
            itemOrder: ["role", "name", "company"],
        }
    }
};

export const defaultTagConfig = tagPresets.printers.zebra_9x5;
